import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {errorMsg, successMsg} from "app/utils/MessageUtils";
import {UserService} from "app/services";
import {fetchAllEmployeeUsers} from "./user-employees-list.slice";

interface DeleteUserStateParams {
  id: string;
  onSuccess?: Function;
  onError?: Function;
}

export const deleteUser = (params: DeleteUserStateParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await UserService.deleteUser(params.id);
    if (response.status >= 200 || response.status < 300) {
      dispatch(setSuccess(true));
      dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Employee deleted successfully!' : 'Punetori u fshi me sukses!'));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(''));
      // @ts-ignore
      dispatch(fetchAllEmployeeUsers());
    }
    dispatch(setLoading(false));
  } catch (err) {
    dispatch(setLoading(false));
    dispatch(errorMsg(err.data.message));
    if (params.onError) params.onError();
    dispatch(setError(err.data.message));
  }
}

interface DeleteUserSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: DeleteUserSlice = {
  error: '',
  success: false,
  loading: false
}

const stateSlice = createSlice({
  name: 'users/delete-user',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setSuccess: (state, action) => {
      state.success = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    }
  }
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;